import { Link } from "react-router-dom";
import { Flame, Search, Home } from "lucide-react";

/**
 * Catch-all route. Previously any unknown URL rendered a blank page, which looks
 * like a broken site rather than a wrong address.
 */
export const NotFoundPage = () => (
  <div className="min-h-screen pt-32 pb-16 px-4 text-center" data-testid="not-found-page">
    <Flame className="w-12 h-12 text-orange-500 mx-auto mb-4" />
    <h1 className="font-heading text-4xl sm:text-5xl font-black mb-2">404</h1>
    <p className="text-sm text-white/50 mb-8">That page is not trending — because it does not exist.</p>

    <div className="flex flex-wrap justify-center gap-3">
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-orange-500 hover:bg-orange-600 text-black text-sm font-bold transition-colors"
      >
        <Home className="w-4 h-4" /> Trending now
      </Link>
      <Link
        to="/search"
        className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/15 hover:bg-white/10 text-sm font-medium transition-colors"
      >
        <Search className="w-4 h-4" /> Search videos
      </Link>
    </div>
  </div>
);
